module.exports = __webpack_public_path__ + "static/media/heroImage.85d28470.webp";